<template>
  <div class="fts-automation-variable">
    <div
      v-for="(value, name, index) in variable"
      :key="`variable-${uid}-${index}`"
    >
      <template v-if="value && isMenu(value)">
        <div class="automation-variable-wrapper">
          <div
            class="automation-variable-menu"
            :class="{ expand: value.expand }"
            @click="toggleMenu(value)"
          >
            <div class="automation-variable-label">
              <i
                class="automation-variable-label__icon"
                :class="informationIcon(value, name)"
                v-if="informationIcon(value, name)"
              ></i>
              <fts-tippy
                trigger-class="automation-variable-label-name"
                :content="name"
                class="automation-variable-label__name"
                v-if="name"
              >
                <template #trigger
                  >{{ name }}
                  <span v-if="isArray(value)"
                    >({{ value.length }})</span
                  ></template
                >
              </fts-tippy>
            </div>
            <font-awesome-icon
              :icon="['fas', 'caret-right']"
              fixed-width
              class="automation-variable-menu__toggle"
            />
          </div>
          <div
            class="automation-variable-tag-wrapper"
            v-if="
              value.header &&
              (value.header.moduleId ||
                value.header.activityId ||
                value.header.informationId)
            "
          >
            <fts-automation-badge
              :module-id="value.header.moduleId"
              :activity-id="value.header.activityId"
              :information-id="value.header.informationId"
              class="automation-variable-tag"
            />
          </div>
        </div>
        <fts-transition-expand>
          <div v-if="value && value.expand">
            <template v-if="isArray(value)">
              <div
                v-for="(item, itemIndex) in value"
                :key="`variable-${uid}-${index}-${itemIndex}`"
              >
                <div class="automation-variable-wrapper">
                  <div
                    class="automation-variable-menu"
                    @click="toggleMenuField(`${uid}-${index}-${itemIndex}`)"
                    :ref="`variable-toggle-${uid}-${index}-${itemIndex}`"
                  >
                    <div class="automation-variable-label">
                      <div class="automation-variable-label__name">
                        <div class="automation-variable-label-name">
                          #{{ itemIndex + 1 }}
                        </div>
                      </div>
                    </div>
                    <font-awesome-icon
                      :icon="['fas', 'caret-right']"
                      fixed-width
                      class="automation-variable-menu__toggle"
                    />
                  </div>
                </div>
                <fts-transition-expand>
                  <div
                    class="automation-variable-content"
                    :ref="`variable-content-${uid}-${index}-${itemIndex}`"
                  >
                    <fts-automation-variable
                      v-if="item.header"
                      :variable="item.data"
                      :base="item.header"
                    />
                    <fts-automation-variable
                      v-else
                      :variable="item"
                      :base="value.header"
                    />
                  </div>
                </fts-transition-expand>
              </div>
            </template>
            <fts-automation-variable
              :variable="value.data"
              :base="value.header"
              v-else
            />
          </div>
        </fts-transition-expand>
      </template>

      <div
        class="automation-variable-wrapper automation-variable-default"
        v-else
      >
        <div class="automation-variable-default__label">
          <div class="automation-variable-label">
            <i
              class="automation-variable-label__icon"
              :class="informationIcon(value, name)"
              v-if="informationIcon(value, name)"
            ></i>
            <fts-tippy
              trigger-class="automation-variable-label-name"
              :content="name"
              class="automation-variable-label__name"
              v-if="name"
            >
              <template #trigger>{{ name }}</template>
            </fts-tippy>
          </div>
          <div class="automation-variable-tag-wrapper">
            <fts-automation-badge
              :module-id="isModule(name)"
              class="automation-variable-tag"
              v-if="isModule(name)"
            />
          </div>
        </div>
        <fts-tippy
          :trigger-class="`automation-variable-default-value ${valueConstructorColor(
            value
          )}`"
          :content="isValue(value) ? value : variableSystemValue(value)"
          class="automation-variable-default__value"
        >
          <template #trigger>{{
            isValue(value) ? value : variableSystemValue(value)
          }}</template>
        </fts-tippy>
      </div>
    </div>
  </div>
</template>

<script>
import { automationDesignStore } from "../../store/automationDesignStore";
import commons from "../../commons/commons";

import FTSTransitionExpand from "../../elements/FTSTransitionExpand";
import FTSTippy from "../../elements/FTSTippy";
import FTSAutomationBadge from "./FTSAutomationBadge";

export default {
  name: "fts-automation-variable",
  props: ["variable", "base"],
  components: {
    "fts-transition-expand": FTSTransitionExpand,
    "fts-tippy": FTSTippy,
    "fts-automation-badge": FTSAutomationBadge,
  },
  data: () => ({
    module: null,
    uid: null,
  }),
  methods: {
    isModule(name) {
      if (this.module) {
        let info = this.module.information.find((x) => x.displayName == name);
        if (info && info.connectionId) {
          return info.connectionId.toString();
        }
      }
    },
    informationIcon(value, name) {
      if (this.module) {
        let info = this.module.information.find((x) => x.displayName == name);
        if (info) {
          return commons.informationIcon(info.type);
        }
      } else if (value && value.header) {
        if (value.header.activityId) {
          return commons.informationIcon(35);
        } else if (value.header.informationId) {
          return commons.informationIcon(36);
        } else {
          return commons.informationIcon(7);
        }
      }

      if (
        automationDesignStore.state.diagram &&
        automationDesignStore.state.debugPayload.nodeId
      ) {
        let diagram = lodash.cloneDeep(automationDesignStore.state.diagram);
        let node = diagram[automationDesignStore.state.debugPayload.nodeId];
        let variable = node.data.variables.find((x) => x.name == name);
        if (variable) {
          return commons.informationIcon(variable.type);
        }
      }

      return commons.informationIcon(value);
    },
    isMenu(value) {
      return Array.isArray(value) || (typeof value == "object" && value.header);
    },
    isArray(value) {
      return Array.isArray(value);
    },
    isValue(value) {
      const type = Object.prototype.toString.call(value);
      return type === "[object Number]" || type === "[object String]" || type === "[object Boolean]";
    },
    variableSystemValue(value) {
      const type = Object.prototype.toString.call(value);
      switch (type) {
        case "[object Array]":
          return "[ ]";
        case "[object Object]":
          if (value.Text) {
            return value.Text;
          }
          return "{ }";
        case "[object Undefined]":
          return "undefined";
        default:
          return "(empty)";
      }
    },
    toggleMenu(item) {
      if (item.expand) this.$delete(item, "expand");
      else this.$set(item, "expand", true);
    },
    toggleMenuField(item) {
      try {
        let toggle = this.$refs[`variable-toggle-${item}`];
        let content = this.$refs[`variable-content-${item}`];
        if (Array.isArray(toggle)) {
          toggle[0].classList.toggle("expand");
          if (Array.isArray(content)) {
            if (
              toggle[0].classList.contains("expand") &&
              !content[0].classList.contains("expand")
            ) {
              content[0].classList.add("expand");
            } else if (content[0].classList.contains("expand")) {
              content[0].classList.remove("expand");
            }
          }
        }
      } catch (err) {
        console.warn("[DOMException]", err);
      }
    },
    /* experiment */
    valueConstructorColor(value) {
      const type = Object.prototype.toString.call(value);
      switch (type) {
        case "[object Array]":
          return "value--array";
        case "[object Object]":
          return "value--object";
        case "[object Number]":
          return "value--number";
        case "[object String]":
          return "value--string";
        default:
          return "value--null";
      }
    },
  },
  async mounted() {
    this.uid = this._uid;
    if (this.base) {
      let data = await this.$store.dispatch("findVariable", {
        moduleId: this.base.moduleId,
      });

      this.module = data;
    }
  },
};
</script>

<style lang="scss">
@import "./src/assets/scss/vars.scss";

.fts-automation-variable {
  $font-size: 0.875rem;
  $icon-mr: 0.375rem;
  font-size: $font-size;
  & .fts-automation-variable {
    padding-left: calc(#{$font-size + $icon-mr});
  }
  .automation-variable-wrapper {
    padding-top: 0.375rem;
    padding-bottom: 0.375rem;
    &.menu {
      display: flex;
      flex-direction: column;
    }
  }
  .automation-variable-label {
    min-width: 0;
    display: flex;
    align-items: center;
    .automation-variable-label__icon {
      flex-shrink: 0;
      margin-right: $icon-mr;
      color: $grayLightColor;
    }
    .automation-variable-label__name {
      min-width: 0;
      .automation-variable-label-name {
        @include text-overflow-ellipsis;
        font-size: 0.875rem;
      }
    }
    .automation-variable-label__count {
      flex-shrink: 0;
      margin-left: 0.175rem;
    }
  }
  .automation-variable-menu {
    display: flex;
    justify-content: space-between;
    cursor: pointer;
    &.expand {
      .automation-variable-menu__toggle {
        transform: rotate(90deg);
      }
    }
    .automation-variable-menu__toggle {
      margin-left: 0.75rem;
      flex-shrink: 0;
      transition: all 0.3s;
    }
  }
  .automation-variable-content {
    display: none;
    &.expand {
      display: block;
    }
  }
  .automation-variable-tag-wrapper {
    margin-top: 0.135rem;
    margin-left: $font-size + $icon-mr;
  }
  .automation-variable-tag {
    max-width: 100%;
    display: inline-flex;
    padding: 0.1rem 0.375rem;
    border-radius: 0.5rem;
    background: #eee;
    vertical-align: top;
    font-size: 0.675rem;
  }
  .automation-variable-default {
    min-width: 0;
    display: flex;
    .automation-variable-default__label {
      min-width: 0;
      // $mr: 0.75rem;
      // flex: 1 1 calc(50% - #{$mr});
      // max-width: calc(50% - #{$mr});
      // margin-right: $mr;
      flex: 3;
      margin-right: 0.75rem;
      cursor: default;
    }
    .automation-variable-default__value {
      // flex: 1 1 50%;
      // max-width: 50%;
      min-width: 0;
      flex: 1;
      display: flex;
      justify-content: flex-end;
      cursor: default;
      .automation-variable-default-value {
        @include text-overflow-ellipsis;
        /* experiment */
        &.value--string {
          color: #fb8c00;
        }
        &.value--number {
          color: #1e88e5;
        }
        &.value--null {
          color: #8e24aa;
        }
      }
    }
  }
}
</style>